import _ from "lodash";
import { getIn } from "formik";
import React from "react";

import { getAutomationDataAttr } from "../../../../../utils/automationUtils";
import { Text, TextArea, TextColors, TextTypes } from "../../../../../component-library";

import "./CareManagementField.styles.scss";
import "./CareManagementFieldShared.styles.scss";

export const CareManagementField = ({ formikProps, isViewOnly, name, subTitle, testId, title }) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.target.value);
  };

  return (
    <div className="CareManagementFieldShared--wrapper">
      <div className="CareManagementFieldShared--text_wrapper">
        <h3 className="CareManagementFieldShared--title">{title}</h3>
        <h3 className="CareManagementFieldShared--subTitle">{subTitle}</h3>
      </div>
      <div className="CareManagementField--input_wrapper">
        {!isViewOnly && (
          <TextArea
            className="CareManagementField--input"
            error={isTouched && errorMessage}
            ignoreEnterSubmit={true}
            onChange={handleChange}
            placeholder="Type comment..."
            testId={testId}
            value={value}
          />
        )}
        {isViewOnly && (
          <div className="CareManagementField--view_only_input_wrapper">
            <p className="CareManagementField--view_only_input" {...getAutomationDataAttr(testId)}>
              {value === "" ? "None" : value}
            </p>
          </div>
        )}
        {errorMessage && isTouched && (
          <Text color={TextColors.red} layout="block" type={TextTypes.small}>
            {errorMessage}
          </Text>
        )}
      </div>
    </div>
  );
};
